export default {
  mixin: {
    data() {
      return {
        intervalTime: 3000, //轮询间隔默认3秒
        randomId: 0,
        bp: null, //上报的埋点数据,
        requestAnimationFrame: undefined,
        myReq: undefined,
        timeout: {
          doc: 10 * 60 * 1000, //10分钟未操作页面，停止轮询，判定用户挂机
          live: 60 * 60 * 1000, //60分钟未操作页面，停止轮询，判定用户挂机
          '2024answerDoc': 10 * 60 * 1000, //10分钟未操作页面，停止轮询，判定用户挂机 默克文章页
          '2024answerLive': 60 * 60 * 1000, //60分钟未操作页面，停止轮询，判定用户挂机 默克直播页
        },
        lastUseTime: 0, //最近一次使用时间
        left: false, //是否挂机离开,true:挂机；false:使用中
      }
    },
    created() {
      // this.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame
      this.requestAnimationFrame = function (callback) {
        return (
          window.requestAnimationFrame(callback) ||
          window.webkitRequestAnimationFrame(callback) ||
          window.mozRequestAnimationFrame(callback) ||
          window.oRequestAnimationFrame(callback) ||
          window.msRequestAnimationFrame(callback) ||
          function (callback) {
            this.myReq = setInterval(callback, this.intervalTime)
          }
        )
      }
      this.reset()
    },
    mounted() {
      var that = this
      var getSupportedProperty = function getSupportedProperty() {
        var result = {}

        if (typeof document.hidden !== 'undefined') {
          result.hidden = 'hidden'
          result.visibilityChange = 'visibilitychange'
        } else if (typeof document.msHidden !== 'undefined') {
          result.hidden = 'msHidden'
          result.visibilityChange = 'msvisibilitychange'
        } else if (typeof document.webkitHidden !== 'undefined') {
          result.hidden = 'webkitHidden'
          result.visibilityChange = 'webkitvisibilitychange'
        }

        return result
      }
      var visibilityName = getSupportedProperty().visibilityChange

      if (visibilityName) {
        document.addEventListener(
          visibilityName,
          function () {
            // console.log(`stay document.visibilityState=${document.visibilityState}`)
            if (document.visibilityState === 'visible') {
              // console.log(`stay document.visibilityState 恢复计时`)
              if (that.isAndroid14) {
                // 强制重绘关键区域
                const el = document.body
                if (el) {
                  el.style.visibility = 'hidden'
                  el.offsetHeight // 触发重排
                  el.style.visibility = ''
                }
              }
              that.start()
            } else {
              // console.log(`stay document.visibilityState 暂停计时`)
              that.pause()
            }
          }.bind(this),
          false
        )
      }

      window.addEventListener(
        'pagehide',
        function () {
          // console.log(`stay document.visibilityState 暂停计时(ios)`)
          that.pause()
        }.bind(this),
        false
      )
      window.onscroll = function () {
        that.handleStayScroll()
      }
    },
    methods: {
      handleStayMouseMove() {
        this.handleUserEvent()
        // console.log('stay handleStayMouseMove')
      },
      handleStayTouchMove() {
        this.handleUserEvent()
        // console.log('stay handleStayTouchMove')
      },
      handleStayScroll() {
        this.handleUserEvent()
        // console.log('stay handleStayScroll')
      },
      handleUserEvent() {
        this.lastUseTime = Date.now()
        if (this.left) {
          this.start()
        }
      },
      start() {
        if (this.bp) {
          this.lastUseTime = Date.now()
          this.left = false
          const that = this
          let endTime = Date.now() + this.intervalTime
          function step(timeStamp) {
            const diff = endTime - Date.now()
            if (diff > 0) {
              // console.log(Math.floor(diff / 1000))
              that.myReq = that.requestAnimationFrame(step)
            } else {
              that.cancelAnimationFrame(that.myReq)
              // console.log(diff)
              const path = that.$route.path.split('/')[1]
              // console.log('stay on path: ' + path,'path: ' + that.$route.path)
              //符合规则的path才上报埋点
              if (that.timeout[path]) {
                let sec = that.intervalTime / 1000
                that.trackAliyunBuriedPoint(sec)
              }
              // console.log('stay on path: ' + path,'path2: ' + that.timeout[path2])
              if (that.timeout[path] && Date.now() - that.lastUseTime <= that.timeout[path]) {
                endTime = Date.now() + that.intervalTime
                that.myReq = that.requestAnimationFrame(step)
              } else {
                that.left = true
                // console.log('stay 用户长时间未操作,挂机')
              }
            }
          }
          this.myReq = this.requestAnimationFrame(step)
        }

        // this.myReq = requestAnimationFrame(()=> {
        //   const diff = endTime - Date.now()
        //     if(diff > 0) {
        //         console.log(Math.floor(diff / 1000))
        //         this.myReq = requestAnimationFrame()
        //     }
        // });
        // this.intervalId = setInterval(() => {
        //   this.trackAliyunBuriedPoint()
        // }, this.intervalTime)
      },
      pause() {
        this.cancelAnimationFrame()
      },
      cancelAnimationFrame() {
        if (this.myReq) {
          const caf =
            window.cancelAnimationFrame ||
            window.mozCancelAnimationFrame ||
            function (id) {
              clearInterval(id)
            }
          if (caf) {
            caf(this.myReq)
          }
        }
      },
      reset() {
        this.pause()
        // clearInterval(this.intervalId)
        let randomNum = ''
        for (let x = 0; x < 10; x++) {
          randomNum += Math.floor(Math.random() * 9 + 1)
        }
        let nowTime = Date.now().toFixed(0)
        // 时间戳+十位随机数
        this.randomId = '' + nowTime + randomNum
        this.bp = null
      },
      /**
       * 开启轮询
       * @param data json对象
       */
      setBuriedPointContentDetailStay(data) {
        // console.log('path:',this.$route,this.$route.path,this.$route.path.split('/')[1])
        this.bp = { ...data }
        this.start()

        // 初始值随机1-3秒
        let randomSec = Math.floor(Math.random() * 3) + 1
        this.trackAliyunBuriedPoint(randomSec)
      },
      /**
       * 上报埋点到阿里云
       */
      async trackAliyunBuriedPoint(second) {
        //有auth，没有userId时，请求新的userId并缓存
        if (window.head.auth && !sessionStorage.getItem('userId')) {
          let apiurl = Global_apiserver + '/api/user/v3/exChangeAuthUid'
          let postData = { head }
          let { data } = await this.$axios.post(apiurl, postData)
          if (data.uid && data.uid > 0) {
            sessionStorage.setItem('userId', data.uid)
          }
          //重新请求
          this.trackAliyunBuriedPoint(second)
        } else {
          if (this.bp) {
            let laiyuan = 'wx'
            if (is_app()) {
              if (browser.versions.android) {
                laiyuan = 'Android'
              } else {
                laiyuan = 'iOS'
              }
            } else {
              if (window.ISWX) {
                laiyuan = 'wx'
              } else if (window.ISWXMINI) {
                laiyuan = '小程序'
              } else if (window.ISPC) {
                laiyuan = 'pc'
              } else {
                laiyuan = 'mb'
              }
            }

            this.bp.content_url = self.location.href
            this.bp.laiyuan = laiyuan
            this.bp.uuid = localStorage.getItem('AnonymousID')
            this.bp.random_id = this.randomId
            this.bp.funname = 'ContentDetailStay'

            // console.log('funname:ContentDetailStay;userId',sessionStorage.getItem('userId'));
            if (sessionStorage.getItem('userId')) {
              this.bp.userid = sessionStorage.getItem('userId')
            } else {
              this.bp.userid = localStorage.getItem('AnonymousID')
            }
            const type = process.env.MODE
            let env = 'dev'
            if (type === 'dev' || type === 'test') {
              env = 'dev'
            } else if (type === 'pre') {
              env = 'pre'
            } else {
              env = 'prod'
            }
            this.bp.env = env
            this.bp.view_time = second
          }
          aliyunlog(this.bp)
        }

        // console.log('stay 上报阿里云:', this.bp)
      },
    },
    computed: {
      isAndroid14() {
        if (is_app() && browser.versions.android && window && window.head && window.head.extensions) {
          // 遍历数组中的每个对象
          for (let i = 0; i < window.head.extensions.length; i++) {
            // 检查当前对象的name属性是否与查询的属性名匹配
            if (window.head.extensions[i].name === 'phoneVersion') {
              // 如果匹配，返回该对象的value
              return window.head.extensions[i].value >= 14
            }
          }
        }
        // 如果没有找到匹配的对象，返回undefined
        return false
      },
    },
    watch: {
      $route(to, from) {
        this.reset()
      },
    },
    beforeDestroy() {
      if (this.myReq && this.cancelAnimationFrame) {
        this.cancelAnimationFrame(this.myReq)
      }
    },
  },
}
